export default __webpack_public_path__ + "static/media/coffee.f6f62784.jpg";